import React from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';

/**
 * IutePay's monthly-price line ("As low as 1 250 L/mo with iute"), shown
 * when the store has IutePay switched on. IUTE's script (loaded on every
 * page by IutePayBootstrap) fills the element and opens its explainer on
 * click; prices it can't finance stay empty, so nothing shows for them.
 *
 * pageType: product | category | cart | payment (IUTE changes the wording).
 * Keyed on amount and SKU: IUTE fills an element once, so a new price
 * (another option chosen) needs a fresh element.
 */
const IuteInstalments = ({ amount, sku, pageType = 'product', className = '' }) => {
  const { iutepay } = useSiteSettings();
  const value = Math.round(Number(amount));
  if (!iutepay || !sku || !Number.isFinite(value) || value <= 0) return null;

  return (
    <div
      key={`${sku}-${value}`}
      className={`${pageType === 'category' ? 'iute-from' : 'iute-as-low-as'} iute-instalments ${className}`.trim()}
      data-amount={value}
      data-page-type={pageType}
      data-sku={sku}
      data-logo-type={pageType === 'category' ? 'text' : undefined}
      data-testid="iute-instalments"
    />
  );
};

export default IuteInstalments;
